import type { StoryT } from '@root/src/types';
import { twcls } from '@utils/twcls';
import { observer } from 'mobx-react';
import type { FC } from 'react';
import Picture from '../Picture';
import icons from '@icons';

import LoadingSkeleton from '@components/LoadingSkeleton';

const {
  eyeOff2: { white: eyeOff2WhiteOutlined }
} = icons.Outline;

interface StoryCardProps {
  item: StoryT;
  onClick: () => void;
}

export const StoryCardLoading: FC = () => (
  <LoadingSkeleton className='relative keen-slider__slide h-full w-full overflow-hidden !rounded-xl' />
);

export const StoryCard: FC<StoryCardProps> = observer(({ item, onClick }) => {
  const backgroundImage =
    item?.fileItem?.cacheItem?.[0]?.filePath || item.image;

  return (
    <div
      onClick={onClick}
      className={twcls(`
      group
      relative
      p-3
      h-full
      w-full
      overflow-hidden
      text-white
      bg-no-repeat
      bg-cover
      cursor-pointer
      keen-slider__slide
      rounded-xl
    `)}
      style={
        backgroundImage
          ? { backgroundImage: `url("${backgroundImage}")` }
          : undefined
      }
    >
      <div
        className={twcls(`
        bg-gradient-to-b
        from-[#00000066]
        transition-all
        to-transparent
        absolute
        top-0
        left-0
        z-0
        opacity-100
        group-hover:opacity-10
        group-hover:transition-all
        group-hover:duration-150
        w-full
        h-full`)}
      />
      <div className='relative z-10 mb-4'>
        {item.title && (
          <div
            dangerouslySetInnerHTML={{
              __html: item.title
            }}
            className='mb-3 text-xl font-medium allMd:font-normal allMd:text-base'
          />
        )}
      </div>
      {item?.label && (
        <div className='relative z-20 px-2 py-1 text-xs leading-none text-[var(--main-font-color)] bg-white rounded-lg w-max'>
          {item.label}
        </div>
      )}
      {item.alreadyWatched && (
        <Picture
          className={'absolute bottom-2 right-2 opacity-50'}
          icon={eyeOff2WhiteOutlined}
          width='24'
          height='24'
        />
      )}
    </div>
  );
});
